export default __webpack_public_path__ + "static/data-free-for-beta-36b6431b3879004b2cf81c4bea604054.png";